import { useEffect } from 'react';

export function PointerEventsGuard() {
  useEffect(() => {
    if (typeof document === 'undefined') return;

    const restore = () => {
      try {
        if (getComputedStyle(document.body).pointerEvents === 'none') {
          document.body.style.pointerEvents = 'auto';
          document.documentElement.style.pointerEvents = 'auto';
        }
      } catch {}
    };

    // Observe inline style changes on body
    const observer = new MutationObserver(() => restore());
    observer.observe(document.body, { attributes: true, attributeFilter: ['style'] });

    // Safety net in case setter happens outside mutation path or later
    const interval = window.setInterval(restore, 200);

    // Run once on mount
    restore();

    return () => {
      observer.disconnect();
      clearInterval(interval);
    };
  }, []);

  return null;
}

